import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function EncounterAgents({ data }) {
    const allEncounterAgentsChart = useMemo(() => {
        const source = data?.encountersByAgents || [];

        return {
            totalItems: source.length,
            labels: source.map(item => item.namewar),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    const top10EncounterAgents = useMemo(() => {
        const source = [...(data?.encountersByAgents || [])]
            .sort((a, b) => Number(b.qty || 0) - Number(a.qty || 0))
            .slice(0, 10);

        return {
            labels: source.map(item => item.namewar),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    const chartTile = allEncounterAgentsChart.totalItems > 10 ? "Abordagens por agente (TOP 10)" : "Abordagens por agente"

    useEffect(() => {
        GraphicUtils.barChart(
            "encounter-agents",
            top10EncounterAgents.values,
            top10EncounterAgents.labels,
        );

        if (allEncounterAgentsChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                allEncounterAgentsChart.labels,
                allEncounterAgentsChart.values,
                "Abordagens por agente",
            );
        }
    }, [top10EncounterAgents, allEncounterAgentsChart]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{chartTile}</span>
                <div className="mt-3" id="encounter-agents" />
            </div>
        </>
    )
}